<template>
	<StandardModal
		open
		small
		:title="$t('admin_overview_edit_org_title')"
		:confirmText="$t('common_button_save')"
		:confirmProps="{ disabled, loading }"
		@confirm="saveOrgChanges"
		@cancel="$emit('cancel')"
		ref="modal"
	>
		<div class="edit-org-modal" data-cy="editModal">
			<ProfilePicker
				:user="org"
				size="70px"
				class="org-profile"
				@success="onUploadSuccess"
				@remove="onRemove"
			/>
			<FormItem
				:label="$t('admin_overview_org_name_section_title')"
				:error="!!errors.name"
				:message="errors.name"
			>
				<Input
					v-focus
					class="name-input"
					maxlength="80"
					v-model="name"
					autoFocus
					:placeholder="$t('admin_overview_org_name_section_title')"
					data-cy="editName"
				/>
			</FormItem>
		</div>
	</StandardModal>
</template>

<script>
import {
	StandardModal,
	Input,
	FormItem,
	ProfilePicker,
} from '@/components/common'
import { updateOrg } from '@/api/organization'

export default {
	name: 'EditOrg',
	components: {
		StandardModal,
		Input,
		FormItem,
		ProfilePicker,
	},
	props: ['org'],
	data() {
		return {
			loading: false,
			name: this.org.name || '',
			errors: {},
			fileKey: null,
			shouldRemovePic: false,
		}
	},
	emits: ['cancel', 'success'],
	computed: {
		disabled() {
			if (this.fileKey || this.shouldRemovePic) return false
			return !this.name || this.name === this.org.name
		},
	},
	methods: {
		async saveOrgChanges() {
			this.modalError?.()
			this.errors = {}
			this.loading = true

			try {
				const payload = { name: this.name }
				if (this.fileKey) {
					payload.profilepic = this.fileKey
				} else if (this.shouldRemovePic) {
					payload.profilepic = null
				}
				await updateOrg(payload)
				this.$alert.success(
					this.$t('admin_people_changes_saved_confirmation_label')
				)
				this.fileKey = null
				this.$emit('success')
				this.$refs.modal.closeModal()
			} catch (e) {
				this.displayErrors(e)
			}
			this.loading = false
		},

		onUploadSuccess(upload) {
			this.shouldRemovePic = false
			this.fileKey = upload.key
		},

		onRemove() {
			this.fileKey = null
			this.shouldRemovePic = true
		},

		displayErrors(e) {
			console.error(e)
			if (!e.response?.data?.errors) {
				this.modalError = this.$refs.modal.$alert.error()
				return
			}
			this.errors = Object.entries(e.response?.data?.errors).reduce(
				(acc, [key, errors]) => {
					acc[key] = errors[0].message
					return acc
				},
				{}
			)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.edit-org-modal {
	display: flex;
	flex-direction: column;
	padding: 24px 24px;
}

.org-profile {
	margin-bottom: 24px;
}

.title {
	margin-bottom: 10px;
	font-family: 'Avenir-Black';
	font-size: 24px;
	color: var(--neutral-800);
	text-align: center;
}

.label {
	font-family: 'Avenir-Black';
	font-size: 16px;
	color: var(--neutral-800);
	margin-bottom: 8px;
}
</style>
